import React from "react";

const GoogleIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
  >
    <g clipPath="url(#clip0_1_3580)">
      <path
        d="M24.542 12.8184C24.542 11.9642 24.4491 11.1101 24.3562 10.2559H12.7441V15.0965H19.3398C19.0612 16.615 18.2251 18.0387 16.9246 18.893V22.0251H20.9192C23.2416 19.8422 24.5422 16.615 24.5422 12.8186"
        fill="#4285F4"
      />
      <path
        d="M12.7452 25.0621C16.0894 25.0621 18.8764 23.923 20.9202 22.0248L16.9256 18.8927C15.8108 19.6519 14.4173 20.1265 12.7452 20.1265C9.58651 20.1265 6.79955 17.9435 5.87057 14.9062H1.7832V18.1333C3.91981 22.4044 8.10025 25.0621 12.7452 25.0621Z"
        fill="#34A853"
      />
      <path
        d="M5.87024 14.9065C5.31296 13.3879 5.31296 11.6795 5.87024 10.0659V6.83887H1.78288C0.0176871 10.3507 0.0176871 14.5269 1.78288 18.1336L5.87024 14.9065Z"
        fill="#FBBC04"
      />
      <path
        d="M12.6465 4.86351C14.4116 4.86351 16.0837 5.52797 17.3844 6.76178L20.9145 3.15513C18.6848 1.06697 15.7121 -0.166849 12.7393 -0.0720541C8.09439 -0.0720541 3.82117 2.58562 1.77734 6.85673L5.86485 10.0838C6.70091 7.04646 9.48787 4.86351 12.6465 4.86351Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_3580">
        <rect width="25" height="25" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default GoogleIcon;
